import { IonPage } from "@ionic/react";
import { CircularProgress, Container } from "@mui/material";
import { useEffect } from "react";

import { APP_V2_APP_EVENTS, logEvent } from "../../analytics";
import { CbhLogo } from "../../Content";
import { FULL_SCREEN_LAYOUT_TEXT_COLOR, FullScreenPageLayout } from "../FullScreen";

interface AppLoadingPageProps {
  parentEventName?: string;
  isDebuggingEnabled?: boolean;
}

export function AppLoadingPage({
  parentEventName,
  isDebuggingEnabled = false,
}: AppLoadingPageProps = {}) {
  useEffect(() => {
    if (!isDebuggingEnabled || !parentEventName) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      logEvent(APP_V2_APP_EVENTS.APP_LOADING_TIMEOUT, {
        parentEventName,
        timeoutSeconds: 20,
        timestamp: new Date().toISOString(),
      });
    }, 20_000); // 20 seconds

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isDebuggingEnabled, parentEventName]);

  return (
    <IonPage>
      <FullScreenPageLayout>
        <Container
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: FULL_SCREEN_LAYOUT_TEXT_COLOR,
            gap: 2,
          }}
        >
          <CbhLogo />
          <CircularProgress color="inherit" />
        </Container>
      </FullScreenPageLayout>
    </IonPage>
  );
}
